/**
 * global nav
 */


const nav = () => {
  const $headerBtn = document.querySelector('.js-headerBtn')
  const $navBtn = document.querySelector('.js-navBtn')
  const $nav = document.querySelector('.l-nav.is-header')
  const $overlay = document.querySelector('.l-overlay')
  const $body = document.body
  $headerBtn.addEventListener('click', (e) => {
    e.preventDefault()
    $overlay.classList.add('is-show')
    $nav.classList.add('is-show')
    $body.classList.add('is-fixed')
  });
  $navBtn.addEventListener('click', (e) => {
    e.preventDefault()
    $overlay.classList.remove('is-show')
    $nav.classList.remove('is-show')
    $body.classList.remove('is-fixed')
  });
  $overlay.addEventListener('click', (e) => {
    e.preventDefault()
    $overlay.classList.remove('is-show')
    $nav.classList.remove('is-show')
    $body.classList.remove('is-fixed')
  });
  $overlay.addEventListener('touchmove', (e) => {
    e.preventDefault()
  });

}


export { nav };
